import { PlanningEvent, PlanningStatus } from "../models/planning-event.model";

const STATUS_RANK: Record<PlanningStatus, number> = {
  blocked: 0,
  late: 1,
  partial: 2,
  in_progress: 3,
  pending: 4,
  completed: 5,
  cancelled: 6,
};

/**
 * Tri : 1. severity DESC  2. status rank  3. heure croissante
 * Immutable.
 */
export function sortEventsInCell<P = unknown>(
  events: PlanningEvent<P>[],
): PlanningEvent<P>[] {
  return events.slice().sort((a, b) => {
    const sev = (b.severity ?? 0) - (a.severity ?? 0);
    if (sev !== 0) return sev;

    const st = STATUS_RANK[a.status] - STATUS_RANK[b.status];
    if (st !== 0) return st;

    const ta = a.datePrevu ?? a.dateReel ?? "";
    const tb = b.datePrevu ?? b.dateReel ?? "";
    return ta.localeCompare(tb);
  });
}
